module.exports = __webpack_public_path__ + "static/animal-app-screen-mock-4f0ec0ad9369db47eb50f94de21a29b9.png";